import {useParams} from 'react-router-dom'
import React, { useState } from 'react';

import {FlyWithCustprofile} from '../containers'
function FlyWithCustprofilePage() {
    let { id} = useParams();
    let svparams = { 'id': id}
    return (
        <FlyWithCustprofile svparams= {svparams} />
       
        
       
    );
}
export default FlyWithCustprofilePage